import styled from "styled-components";

export const SocketConnectionStatusStyled = styled.div`
  overflow: hidden;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  height: 40px;
  padding: 5px;

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 99;

  .inner {
    background-color: white;
    width: 25%;
    min-width: 300px;
    border-radius: 10px;
    font-size: 1.2em;
    font-weight: bold;
  }
`;
